import {
    CREATE_JOB_CATEGORY,
    CREATE_JOB_BENEFIT,
    CREATE_JOB_DESCRIPTION,
    CREATE_JOB_REQUIRMENT,
    CREATE_JOB_SUCCESS,
    LOADING
} from './ActionType'
import {
    stateToHTML
} from 'draft-js-export-html'
import axios from 'axios'
import { INSERT_SUCCESS } from '../api/ResponseType';
import { END_POINT_JOBS } from '../api/EndPoint';
import moment from 'moment'
import { JWT } from '../utils/CommonConstant';
import {
    reset
} from 'redux-form'


export const onChangeCategory = (item) => dispatch => {
    dispatch({
        type: CREATE_JOB_CATEGORY,
        payload: item
    })
}

export const onChangeBenefit = (item) => dispatch => {
    dispatch({
        type: CREATE_JOB_BENEFIT,
        payload: item
    })
}

export const onChangeDescription = (value) => dispatch => {

    dispatch({
        type: CREATE_JOB_DESCRIPTION,
        payload: stateToHTML(value)
    })
}

export const onChangeRequirment = (value) => dispatch => {
    dispatch({
        type: CREATE_JOB_REQUIRMENT,
        payload: stateToHTML(value)
    })
}

export const createJob = (props) => dispatch => {

    const { form, position_information} = props

    const request ={
        title: form.title,
        benefits: position_information.benefits,
        category: position_information.category,
        description: position_information.description,
        requirements: position_information.requirements,
        close_date: form.close_date.format("ddd, DD MMM YYYY HH:mm:ss [GMT]"),
        department: form.department,
        entity: form.entity,
        location: form.location,
        salary: {
            max: {
                amount: parseInt(form.max_salary),
                type: form.currency_type
            },
            min: {
                amount: parseInt(form.min_salary),
                type: form.currency_type
            }
        },
        contract: {
            from: form.start_date === undefined ? moment().format("ddd, DD MMM YYYY HH:mm:ss [GMT]") : form.start_date.format("ddd, DD MMM YYYY HH:mm:ss [GMT]"),
            to: form.end_date === undefined ? moment().format("ddd, DD MMM YYYY HH:mm:ss [GMT]") : form.end_date.format("ddd, DD MMM YYYY HH:mm:ss [GMT]"),
            type: form.contract
        }
    }

    axios(
        {
            method: 'post',
            headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': true,
            'Authorization': sessionStorage.getItem(JWT),
            },
            withCredentials: false,
            mode: 'no-cors',
            url: END_POINT_JOBS,
            data: request
        }
    ).then(response => {

        dispatch({
            type: LOADING,
            payload: false
        })

        if(response.status === INSERT_SUCCESS){

            dispatch(reset("create_job"))
            dispatch({
                type: CREATE_JOB_SUCCESS
            })

            window.alert("Successfully Created")
        }else{
            window.alert("Failed")
        }
        
    }).catch( error => {
        dispatch({
            type: LOADING,
            payload: false
        })
        window.alert("Error! "+error)
    })

}